<template>
    <div  :style="oracle.isMobile() ? 'width: 100%;' : 'width: 80%'">
        <div class="d-flex flex-row align-content-center mb-3" v-for="(item, index) in dataMessage" :key="index">
            <img style="border-radius: 0 !important;" :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
                 :src="require('@/assets/image/logo1.png')" alt="">
            <div class="d-flex flex-column flex">
                <v-card style="padding: 10px 20px">
                    <div style="width: 100%" class="d-flex flex-row">
                        <h6 class="font-weight-bold">{{item.message_title}}</h6>
                        <h6 v-if="item.create_at != null" class="font-weight-bold" :class="isEN ? 'ml-auto' : 'mr-auto'">
                            <span style="font-weight: normal !important; font-size: 12px">{{oracle.date(item.create_at)}}</span>
                        </h6>
                    </div>
                    <p style="text-align: unset !important;">{{item.message_body}}</p>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        data: () => ({
            dataMessage: [],
            oracle: oracle,
            language: language,
            isEN: oracle.isEN(),
        }),
        mounted() {
            oracle.axios(
                "setting/getInfo",
                {"filter_by": this.oracle.isEN() ? 'website_en' : 'website', 'search_by': 'message_lawyer'},
                (res) => {
                    let message = {};
                    message.message_title = this.language.lang("Welcome to Visternet");
                    message.message_body = res.data;
                    oracle.axios('message/getAll', {limit_by: 500, offset_by: 0}, (response) => {
                        this.dataMessage.push(message);
                        this.dataMessage.push(...response.data);
                        oracle.axios("message/readAll");
                    })
                }
            );
        }
    };
</script>
<style>
</style>
